<!--
  =====================================================================
  APP - Root Component
  =====================================================================
  
  Componente principale dell'applicazione CRF.
  Gestisce lo stato di caricamento globale e la vista principale.
  
  FEATURES:
  - Gestione overlay di caricamento globale
  - Gestione stato di errore e 404
  - Rendering della HomePage
  
  =====================================================================
-->

<template>
  <div class="app-container">
    <Transition name="fade">
      <div v-if="state.loading" class="loading-overlay">
        <div class="loader-content">

          <p class="loading-text">Caricamento</p>
        </div>
      </div>
    </Transition>

    <NotFoundPage v-if="state.notFound" />
    <HomePage v-else />
  </div>
</template>

<script setup>
// ───────────────────────────────────────────────────────────────────
// IMPORTS
// ───────────────────────────────────────────────────────────────────

import { state } from '@/store/index.js'
import HomePage from './views/HomePage.vue'
import NotFoundPage from './views/NotFoundPage.vue'

</script>

<style lang="scss">
@import "@/assets/styles/main.scss";

.app-container {
  min-height: 100vh;
  position: relative;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(4px);

  .loader-content {
    text-align: center;

    .dots-loader {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: $space-1;
      margin-bottom: $space-1-5;

      .dot {
        width: 14px;
        height: 14px;
        border-radius: 50%;
        animation: dot-pulse 0.9s ease-in-out infinite;

        &.dot-1 {
          background-color: #c9d745;
          animation-delay: 0s;
        }
        &.dot-2 {
          background-color: #8bbb58;
          animation-delay: 0.2s;
        }
        &.dot-3 {
          background-color: #629933;
          animation-delay: 0.4s;
        }
      }
    }

    .loading-text {
      color: $clr-brand-dark;
      font-family: 'Nunito', sans-serif;
      font-weight: 600;
      font-size: $font-base;
      letter-spacing: 0.08em;
      text-transform: uppercase;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@keyframes dot-pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.7);
    opacity: 1;
  }
}
</style>
